import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardContainer from "../../components/dashboard-container";
import { transactionService } from "../../utils/services/billingPaymentService";
import { CircularProgress, Box, Button, Typography } from "@mui/material";
import TransactionList from "../../components/billing-transaction-list";
import CustomPagination from "../../components/pagination";

export default function BillingTransaction() {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [transactionData, setTransactionData] = useState([]);
  const [viewMode, setViewMode] = useState("list");

  const navigate = useNavigate();

  const fetchTransactionData = async () => {
    setLoading(true);
    try {
      const skip = page * rowsPerPage;
      const response = await transactionService.fetch(rowsPerPage, skip);

      setTransactionData((prevData) => {
        const updatedData = response?.data.map((newTxn) => {
          const existingTxn = prevData.find((txn) => txn._id === newTxn._id);
          return existingTxn ? { ...existingTxn, ...newTxn } : newTxn;
        });
        return updatedData;
      });

      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactionData();
  }, [page, rowsPerPage]);

  return (
    <DashboardContainer
      filterButton={false}
      hideAddButton
      hideUploadButton
      hideFilterClient
      header={"Transaction List"}
      setViewMode={setViewMode}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <TransactionList
          data={transactionData}
          itemsPerPage={rowsPerPage}
          currentPage={page}
          viewMode={viewMode}
        />
      )}

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
    </DashboardContainer>
  );
}
